import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * The name cell of a data list row: a pill that opens the item's page. Its
 * click never reaches the row, whose own click filters the page instead.
 */
@Component({
  selector: 'app-data-list-name',
  template: `<button type="button" class="dl-name" (click)="onClick($event)">
    <span class="dl-name-text">{{ name }}</span>
  </button>`,
  styles: [':host { display: inline-flex; min-width: 0; max-width: 100%; }'],
})
export class DataListNameComponent {
  @Input() name = '';
  @Output() navigate = new EventEmitter<void>();

  onClick(event: Event) {
    event.stopPropagation();
    this.navigate.emit();
  }
}
